import { useRouter } from "next/router";
import {
  CoverageCardWrapper,
  CardHeading,
  CardSubHeading,
  CardContent,
  SubHeading
} from "./styles";
import DOMPurify from "isomorphic-dompurify";
import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { convertToLakh } from "@utils/inrFormatter";
import Hyperlink from "@components/common/hyperlink";

const CoverageCard = ({ children, ...props }) => {
  const {
    heading,
    subHeading,
    ncb,
    idv,
    additionalCovers,
    isSelectedPlanTp,
    actions
  } = props || {};
  const { on_click, on_click_idv } = actions || {};
  const handleClick = () => {
    if (on_click?.length > 0) {
      on_click.forEach((eachFunc: any, index: number) => {
        if (typeof eachFunc.funCall === "function") {
          eachFunc.funCall(eachFunc.args);
        }
      });
    }
  };

  const handleClickIdv = () => {
    if (on_click_idv?.length > 0) {
      on_click_idv.forEach((eachFunc: any, index: number) => {
        if (typeof eachFunc.funCall === "function") {
          eachFunc.funCall(eachFunc.args);
        }
      });
    }
  };

  return (
    <Box>
      <CoverageCardWrapper>
        <CardHeading>{heading}</CardHeading>
        {!isSelectedPlanTp && (
          <SubHeading>
            With <span>{ncb}</span> and{" "}
            <span className="idv-span" onClick={handleClickIdv}>
              ₹{convertToLakh(idv)} lakh IDV
            </span>
          </SubHeading>
        )}
        <CardSubHeading>
          <span
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(subHeading)
            }}
          />
          <Hyperlink
            clickHandler={handleClick}
            is_visible={true}
            text=" Learn more"
            type="UNDERLINE"
            styles={{
              display: "inline",
              color: "#36354C",
              fontWeight: "500",
              marginLeft: "4px",
              cursor: "pointer"
            }}
          />
        </CardSubHeading>
        {additionalCovers?.some((addon) => addon.is_selected) && (
          <CardContent>
            <div
              style={{
                color: "#5B5675",
                fontWeight: 500,
                marginBottom: "12px"
              }}
            >
              Additional Covers
            </div>
            <ul>
              {additionalCovers
                .filter((addon) => addon.is_selected)
                .map((addon, index) => (
                  <li key={index}>{addon.display_name}</li>
                ))}
            </ul>
          </CardContent>
        )}
      </CoverageCardWrapper>
    </Box>
  );
};

export default CoverageCard;
